var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotosActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.208 22.875H28.958L24.792 17.292L20.542 22.542L17.833 19.417ZM13.083 28.167Q12.083 28.167 11.417 27.5Q10.75 26.833 10.75 25.833V7.833Q10.75 6.833 11.417 6.167Q12.083 5.5 13.083 5.5H31.083Q32.083 5.5 32.75 6.167Q33.417 6.833 33.417 7.833V25.833Q33.417 26.833 32.75 27.5Q32.083 28.167 31.083 28.167ZM8.917 32.333Q7.917 32.333 7.25 31.667Q6.583 31 6.583 30V11H7.583V30Q7.583 30.5 8 30.917Q8.417 31.333 8.917 31.333H27.917V32.333Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotosActive);
export default __webpack_public_path__ + "static/media/photos_active.b302f0ee27e9f989be01230eb3ddf655.svg";
export { ForwardRef as ReactComponent };